import { connect } from 'react-redux';
import { compose } from 'ramda';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { toggleProjectListSlider } from '../../store/project';
import { withEmptyRendering } from '../../utils/hoc';
import { mergeUrlWithAdditionalQuery } from '../../utils/mergeUrlWithAdditionalQuery';
import { ProjectListBlock, IProjectListBlockProps } from './ProjectListBlock';

type TProjectListBlockStateProps = Pick<IProjectListBlockProps, 'list' | 'isCollapsed'>;
type TProjectListBlockDispatchProps = Pick<IProjectListBlockProps, 'onCollapseLinkClick'>;

export function shouldHideProjectList({ list }: TProjectListBlockStateProps) {
  return !list || !list.length;
}

export function mapStateToProps(state: IState): TProjectListBlockStateProps {
  const projectsData = state.offerData.countrysideProjects;

  if (!state.isProjectListEnabled || !projectsData) {
    return { list: [], isCollapsed: true };
  }

  return {
    list: projectsData.projects.map(project => ({
      ...project,
      url: mergeUrlWithAdditionalQuery(project.url, `offerId=${state.offerData.offer.id}`),
    })),
    isCollapsed: projectsData.areProjectsHidden,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>): TProjectListBlockDispatchProps {
  return {
    onCollapseLinkClick: (isHidden: boolean) => dispatch(toggleProjectListSlider(isHidden)),
  };
}

export const ProjectListBlockContainer = compose(
  connect<TProjectListBlockStateProps, TProjectListBlockDispatchProps>(mapStateToProps, mapDispatchToProps),
  withEmptyRendering(shouldHideProjectList),
)(ProjectListBlock);
